/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Grid from "@mui/material/Grid";
import summaryStyle from "@/src/components/Form/ProcessCostSupport/summaryStyle";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";

type IncomeSummaryProps = {
  formData: Record<string, any>;
};

const IncomeSummary = ({ formData }: IncomeSummaryProps) => {
  return (
    <>
      <Grid sx={summaryStyle.subHeadline} size={12}>
        <Typography variant={"h6"}>Einnahmen</Typography>
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"hasSocialWelfare"} />
        Sozialhilfe
      </Grid>
      <Grid size={12}>
        {formData.hasSocialWelfare === "yes" ? "Es wird Sozialhilfe bezogen" : "Es wird keine Sozialhilfe bezogen"}
      </Grid>
      <>
        <Grid sx={summaryStyle.question} size={12}>
          Einkommensarten
        </Grid>

        <Box id={"hasIncomeEmployment"} />
        <Grid size={12}>
          {formData.hasIncomeEmployment === "yes" ? "Arbeitnehmerlohn: " + formData.incomeEmploymentAmount + " €" : "Kein Arbeitnehmerlohn"}
        </Grid>

        <Box id={"hasIncomeSelfEmployment"} />
        <Grid sx={summaryStyle.addMargin} size={12}>
          {formData.hasIncomeSelfEmployment === "yes"
            ? "Selbstständigkeit: " + formData.incomeSelfEmploymentAmount + " €"
            : "Kein Einkommen als Selbstständiger"}
        </Grid>

        <Box id={"hasIncomeRent"} />
        <Grid sx={summaryStyle.addMargin} size={12}>
          {formData.hasIncomeRent === "yes" ? "Mieteinnahmen: " + formData.incomeRentAmount + " €" : "Keine Mieteinnahmen"}
        </Grid>

        <Box id={"hasIncomeAssets"} />
        <Grid sx={summaryStyle.addMargin} size={12}>
          {formData.hasIncomeAssets === "yes" ? "Kapitalvermögenserträge: " + formData.incomeAssetsAmount + " €" : "Keine Kapitalvermögenserträge"}
        </Grid>

        <Box id={"hasIncomeChildAllowance"} />
        <Grid sx={summaryStyle.addMargin} size={12}>
          {formData.hasIncomeChildAllowance === "yes" ? "Kindergeld/-zuschlag: " + formData.incomeChildAllowanceAmount + " €" : "Kindergeld/-zuschlag"}
        </Grid>

        <Box id={"hasIncomeLiving"} />
        <Grid sx={summaryStyle.addMargin} size={12}>
          {formData.hasIncomeLiving === "yes" ? "Wohngeld: " + formData.incomeLivingAmount + " €" : "Kein Wohngeld"}
        </Grid>

        <Box id={"hasIncomeAlimony"} />
        <Grid sx={summaryStyle.addMargin} size={12}>
          {formData.hasIncomeAlimony === "yes" ? "Unterhalt: " + formData.incomeAlimonyAmount + " €" : "Keinen Unterhalt"}
        </Grid>

        <Box id={"hasIncomePension"} />
        <Grid sx={summaryStyle.addMargin} size={12}>
          {formData.hasIncomePension === "yes" ? "Rente/Pension: " + formData.incomePensionAmount + " €" : "Keine Rente/Pension"}
        </Grid>

        <Box id={"hasIncomeUnemploymentAllowance"} />
        <Grid sx={summaryStyle.addMargin} size={12}>
          {formData.hasIncomeUnemploymentAllowance === "yes"
            ? "Arbeitslosengeld I: " + formData.incomeUnemploymentAllowanceAmount + " €"
            : "Kein Arbeitslosengeld I"}
        </Grid>

        <Box id={"hasIncomeUnemploymentAllowance2"} />
        <Grid sx={summaryStyle.addMargin} size={12}>
          {formData.hasIncomeUnemploymentAllowance2 === "yes"
            ? "Arbeitslosengeld II: " + formData.incomeUnemploymentAllowance2Amount + " €"
            : "Kein Arbeitslosengeld II"}
        </Grid>

        <Box id={"hasIncomeSickness"} />
        <Grid sx={summaryStyle.addMargin} size={12}>
          {formData.hasIncomeSickness === "yes" ? "Krankengeld: " + formData.incomeSicknessAmount + " €" : "Kein Krankengeld"}
        </Grid>

        <Box id={"hasIncomeParentalAllowance"} />
        <Grid sx={summaryStyle.addMargin} size={12}>
          {formData.hasIncomeParentalAllowance === "yes" ? "Elterngeld: " + formData.incomeParentalAllowanceAmount + " €" : "Kein Elterngeld"}
        </Grid>

        <Grid sx={summaryStyle.question} size={12}>
          <Box id={"hasIncomeOther1"} />
          Sonstiges Einkommen
        </Grid>
        <Grid size={12}>
          {formData.hasIncomeOther1 === "yes" ? (
            <>
              <br />
              Beschreibung: {formData.incomeOther1Name} mit einem Bruttobetrag von {formData.incomeOther1Amount} € ({formData.incomeOther1Period})
            </>
          ) : (
            "Kein sonstiges Einkommen"
          )}
          {formData.hasIncomeOther2 === "yes" && (
            <>
              <br />
              <br />
              Beschreibung: {formData.incomeOther2Name} mit einem Bruttobetrag von {formData.incomeOther2Amount} € ({formData.incomeOther2Period})
            </>
          )}
        </Grid>

        {formData.incomeDescription && (
          <>
            <Box id={"incomeDescription"} />
            <Grid size={12}>
              Beschreibung: {formData.incomeDescription}
            </Grid>
          </>
        )}
      </>
    </>
  );
};

export default IncomeSummary;
